import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd2de73e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "c-hero-banner__title"
}
const _hoisted_2 = {
  key: 3,
  class: "c-hero-banner__description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkButton = _resolveComponent("LinkButton")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "c-hero-banner__title-anim",
    mode: "out-in",
    appear: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("div", {
        key: _ctx.title,
        class: _normalizeClass(["c-hero-banner__content", {'c-hero-banner__text-shadows': _ctx.content.isScrimEnabled}])
      }, [
        (_ctx.content.topTitle)
          ? (_openBlock(), _createElementBlock("h1", {
              key: 0,
              class: _normalizeClass(["c-hero-banner__title-prefix", {'font-cormorant text-26 lg:text-28 xl:text-36': _ctx.content.useAlternativeFontTopTitle}])
            }, _toDisplayString(_ctx.content.topTitle), 3))
          : _createCommentVNode("", true),
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        (_ctx.content.bottomTitle)
          ? (_openBlock(), _createElementBlock("h2", {
              key: 2,
              class: _normalizeClass(["c-hero-banner__sub-title o-text-h4", {'italic font-cormorant text-18 lg:text-20 xl:text-26': _ctx.italicBottomTitle}])
            }, _toDisplayString(_ctx.content.bottomTitle), 3))
          : _createCommentVNode("", true),
        (_ctx.content.bottomTitleSubtext)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.content.bottomTitleSubtext), 1))
          : _createCommentVNode("", true),
        (_ctx.shouldShowLinkButton)
          ? (_openBlock(), _createBlock(_component_LinkButton, {
              key: 4,
              link: _ctx.content.link,
              scrim: _ctx.content.isScrimEnabled,
              class: "mt-30"
            }, null, 8, ["link", "scrim"]))
          : _createCommentVNode("", true)
      ], 2))
    ]),
    _: 1
  }))
}